import React, { useState } from 'react';
import './BasicCalculator.css';

const BasicCalculator = () => {
  const [result, setResult] = useState('');
  const [history, setHistory] = useState([]);
  const [soundEnabled, setSoundEnabled] = useState(true);
  const [backlitEnabled, setBacklitEnabled] = useState(true);
  const [backlitColor, setBacklitColor] = useState('#ffffff');

  const handleClick = (e) => {
    if (soundEnabled) {
      setSoundEnabled(!soundEnabled);
    }
    setResult(result.concat(e.target.name));
  };

  const clear = () => {
    setResult('');
  };

  const backspace = () => {
    setResult(result.slice(0, -1));
  };

  // const calculate = () => {
  //   let expression = result;
  //   let calculatedResult;
  //   try {
  //     // Evaluating the expression safely using Function constructor
  //     const evaluate = new Function('return ' + expression);
  //     calculatedResult = evaluate();
  //     setHistory([...history, { expression, result: calculatedResult }]);
  //     setResult(calculatedResult.toString());
  //   } catch (error) {
  //     setResult('Error');
  //   }
  // };

  const calculate = () => {
    let expression = result;
    let calculatedResult;
    try {
      // Using the 'mathjs' library for safe evaluation of mathematical expressions
      // const math = require('mathjs');
      calculatedResult = math.evaluate(expression);
      setHistory([...history, { expression, result: calculatedResult }]);
      setResult(calculatedResult.toString());
    } catch (error) {
      setResult('Error');
    }
  };

  const square = () => {
    setResult(Math.pow(parseFloat(result), 2).toString());
  };

  const squareRoot = () => {
    setResult(Math.sqrt(parseFloat(result)).toString());
  };

  const percent = () => {
    setResult((parseFloat(result) / 100).toString());
  };

  const printHistory = () => {
    const content = history.map((item) => `${item.expression} = ${item.result}`).join('\n');
    const printWindow = window.open('', '_blank');
    printWindow.document.open();
    printWindow.document.write(`<pre>${content}</pre>`);
    printWindow.document.close();
    printWindow.print();
  };

  const shareHistory = async () => {
    try {
      const historyText = history.map((item) => `${item.expression} = ${item.result}`).join('\n');
      await navigator.share({ text: historyText });
    } catch (error) {
      console.error('Sharing failed:', error);
    }
  };

  const handleSoundToggle = () => {
    setSoundEnabled(!soundEnabled);
  };

  const handleBacklitToggle = () => {
    setBacklitEnabled(!backlitEnabled);
  };

  const handleBacklitColorChange = (e) => {
    setBacklitColor(e.target.value);
  };

  const showBarGraph = (expression) => {
    // Implement code to display bar graph for the given expression
  };

  const showLineGraph = (expression) => {
    // Implement code to display line graph for the given expression
  };

  const showPieChart = (expression) => {
    // Implement code to display pie chart for the given expression
  };

  return (
    <div className="p-4 selection:bg-black text-white [&_P]:text-white ">
      <input
        type="text"
        value={result}
        className='p-4 h-12 text-black'
        style={{ backgroundColor: backlitEnabled ? backlitColor : 'transparent' }}
      />
      <div className="keypad">
        <button onClick={clear} className="clear">C</button>
        <button onClick={backspace} className="backspace">CE</button>
        <button name="/" onClick={handleClick}>/</button>
        <button name="7" onClick={handleClick}>7</button>
        <button name="8" onClick={handleClick}>8</button>
        <button name="9" onClick={handleClick}>9</button>
        <button name="*" onClick={handleClick}>*</button>
        <button name="4" onClick={handleClick}>4</button>
        <button name="5" onClick={handleClick}>5</button>
        <button name="6" onClick={handleClick}>6</button>
        <button name="-" onClick={handleClick}>-</button>
        <button name="1" onClick={handleClick}>1</button>
        <button name="2" onClick={handleClick}>2</button>
        <button name="3" onClick={handleClick}>3</button>
        <button name="+" onClick={handleClick}>+</button>
        <button name="0" onClick={handleClick}>0</button>
        <button name="." onClick={handleClick}>.</button>
        <button onClick={percent}>%</button>
        <button onClick={calculate} className="equal">=</button>
        <button onClick={square}>x<sup>2</sup></button>
        <button onClick={squareRoot}>√</button>
        <button className="text-xs lg:text-sm w-40 lg:w-32" onClick={printHistory}>Print History</button>
        <button className="text-xs lg:text-sm w-20 lg:w-28" onClick={shareHistory}>Share</button>
      </div>
      <div className="flex justify-center gap-8">
        <label className="text-sm lg:text-lg gap-4">
          <input type="checkbox" checked={soundEnabled} onChange={handleSoundToggle} />
          Sound
        </label>
        <label className="text-sm lg:text-lg gap-4">
          <input type="checkbox" checked={backlitEnabled} onChange={handleBacklitToggle} />
          Backlit
        </label>
        <label>
          <input
            type="color"
            value={backlitColor}
            onChange={handleBacklitColorChange}
            disabled={!backlitEnabled}
          />
        </label>
      </div>
      <div className="history">
        <h3 className='text-cyna-200 text-sm lg:text-lg'>History</h3>
        <ul>
          {history.map((item, index) => (
            <li className="text-white" key={index}>
              {item.expression} = {item.result}
            </li>
          ))}
        </ul>
        <div className="grid grid-cols-3 place-items-center">
          <button className="bg-blue-500 text-white" onClick={() => showBarGraph(result)}>Bar Graph</button>
          <button className="bg-blue-500 text-white" onClick={() => showLineGraph(result)}>Line Graph</button>
          <button className="bg-blue-500 text-white" onClick={() => showPieChart(result)}>Pie Chart</button>
        </div>
      </div>
    </div>
  );
};

export default BasicCalculator;
